module.exports = __webpack_public_path__ + "static/img/logo1.3a72de4.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/logo1.png
// module id = nbnq
// module chunks = 6